<template>
	<div class="lazyload" ref="container" :style=" { minHeight: refinedMinHeight + 'px', opacity: loaded ? 1 : 0 }">
		<slot v-if="loaded"></slot>
	</div>
</template>
<script>
	export default {
		name: 'Lazyload',
		props: {
			scrollY: {
				type: Number,
				required: true,
			},
			offset: {
				type: Number,
				default: 500,
			},
			minHeight: {
				type: Number,
				default: 600,
			},
			forceLoad: {
				type: Boolean,
				default: false,
			},
			debug: {
				type: Boolean,
				default: false,
			}
		},
		data: function() {
			return {
				posY: -1,
				loaded: false,
				ready: false,
			}
		},
		computed: {
			visible: function() {
				if (!this.ready) return false
				return this.scrollY > this.posY - this.offset 
			},
			refinedMinHeight: function() {
				if (this.loaded) return 0
				return this.minHeight
			},
		},
		watch: {
			visible: function(value) {
				if (value) this.loaded = true
			},
			loaded: function() {
				if (this.debug) console.log('Lazyload component loaded')
			} 
		},
		updated() {
			this.$nextTick(() => {
				this.posY = this.$refs.container.getBoundingClientRect().top - window.scrollY
			})
		},
		mounted() {
			this.$nextTick(() => {
				this.posY = this.$refs.container.getBoundingClientRect().top - window.scrollY
				this.ready = true
				if (this.forceLoad) this.loaded = true
			})			
		}
	}
</script>
<style lang="scss">
	.container {
		transition: opacity .4s linear;
	}
</style>